module.exports = __webpack_public_path__ + "be4c572de278d2ae39be9b546f63d3be.svg";